function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function (e) {
  var t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var o = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 0);
}([function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = r(1);
  Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function get() {
      return (e = n, e && e.__esModule ? e : {
        default: e
      }).default;
      var e;
    }
  });
}, function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = a(r(2)),
      o = a(r(3)),
      u = r(6);

  function a(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var l = function l(e) {
    var t = e.className,
        r = e.style,
        o = function (e, t) {
      var r = {};

      for (var n in e) {
        t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
      }

      return r;
    }(e, ["className", "style"]);

    return n.default.createElement("span", {
      className: t,
      style: r
    }, (0, u.pluralize)(o));
  };

  l.propTypes = {
    singular: o.default.string.isRequired,
    plural: o.default.string,
    count: o.default.number,
    showCount: o.default.bool,
    className: o.default.string,
    style: o.default.object,
    zero: o.default.string
  }, l.defaultProps = {
    count: 1,
    showCount: !0,
    className: null,
    style: {},
    zero: null
  }, t.default = l;
}, function (e, t) {
  e.exports = require("react");
}, function (e, t, r) {
  e.exports = r(4)();
}, function (e, t, r) {
  "use strict";

  var n = r(5);

  function o() {}

  function u() {}

  u.resetWarningCache = o, e.exports = function () {
    function e(e, t, r, o, u, a) {
      if (a !== n) {
        var l = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw l.name = "Invariant Violation", l;
      }
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var r = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      elementType: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t,
      checkPropTypes: u,
      resetWarningCache: o
    };
    return r.PropTypes = r, r;
  };
}, function (e, t, r) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.pluralize = void 0;
  var n = r(7);
  t.pluralize = n.pluralize;
}, function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  t.pluralize = function (e) {
    var t = e.singular,
        r = e.plural,
        n = e.count,
        o = e.showCount,
        u = e.zero;
    if (0 === n && u) return u;
    var a = t;
    return 1 !== n && (a = r || t + "s"), o ? n + " " + a : a;
  };
}]);